/*
import loadScript from 'loader';

loadScript('my-non-bundled-script.js')
  .then(() => {
    // do something after loading the script
  })
  .catch(e => {
    console.error(e);
  });
*/
var assetCache = new Map();
export var loadScript = function loadScript(url, name) {
  if (assetCache.has(url)) {
    return assetCache.get(url);
  }

  var promise = new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.id = "loaded-script-".concat(assetCache.size);
    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);
    script.async = true;
    script.src = url;

    if (document.currentScript) {
      document.currentScript.parentNode.insertBefore(script, document.currentScript);
    } else {
      (document.head || document.getElementsByTagName('head')[0]).appendChild(script);
    }
  });
  assetCache.set(url, promise); // Allow for loadScript(myURL, 'MyObj').then(MyObj => { console.log('MyObj loaded', MyObj)});
  // Script should add window.MyObj

  if (name && global[name]) {
    return promise.then(function () {
      return global[name];
    });
  }

  return promise;
};
export var loadCSS = function loadCSS(url) {
  if (assetCache.has(url)) {
    return assetCache.get(url);
  }

  var promise = new Promise(function (resolve, reject) {
    var link = document.createElement('link');
    link.id = "loaded-css-".concat(assetCache.size);
    link.addEventListener('load', resolve);
    link.addEventListener('error', function () {
      return reject(new Error("Failed to load css '".concat(url, "'.")));
    });
    link.rel = 'stylesheet';
    link.href = url;
    (document.head || document.getElementsByTagName('head')[0]).appendChild(link);
  });
  assetCache.set(url, promise);
  return promise;
}; // Used for polyfilling (promises in particular), purposely implemented without promises

export var legacyLoadScript = function legacyLoadScript(url, resolve, reject) {
  reject = reject || resolve;
  var script = document.createElement('script');
  script.addEventListener('load', resolve);
  script.addEventListener('error', function () {
    return reject(new Error("Failed to load script '".concat(url, "'.")));
  });
  script.async = true;
  script.src = url;

  if (document.currentScript) {
    document.currentScript.parentNode.insertBefore(script, document.currentScript);
  } else {
    (document.head || document.getElementsByTagName('head')[0]).appendChild(script);
  }
};